import { usePopularLocationsQuery } from '@/hooks/RQHooks/tour/main/usePopularLocationsQuery';
import useEmblaCarousel from 'embla-carousel-react';
import { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import LocationTop10List from '../common/LocationTop10List';
import SectionTitle from '../common/SectionTitle';

export default function LocationPopularSection() {
  const { data, isPending } = usePopularLocationsQuery();
  const [activeButton, setActiveButton] = useState<string | null>(null);
  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps',
  });

  useEffect(() => {
    if (!data || data.length === 0) return;
    setActiveButton(data[0].location);
  }, [data]);

  return (
    <div>
      <SectionTitle title={'이번엔 어디로 가볼까?'} slogan={'루플이 추천하는 방방곡곡 BEST'} />
      <ButtonCarouselWrapper>
        <Embla ref={emblaRef}>
          <EmblaContainer>
            {data?.map((button) => (
              <EmblaSlide key={button.location}>
                <StyledButton
                  active={activeButton === button.location}
                  onClick={() => setActiveButton(button.location)}>
                  {button.location}
                </StyledButton>
              </EmblaSlide>
            ))}
          </EmblaContainer>
        </Embla>
      </ButtonCarouselWrapper>
      {activeButton && <LocationTop10List location={activeButton} />}
    </div>
  );
}

const ButtonCarouselWrapper = styled.div`
  margin-bottom: 20px;
`;

const Embla = styled.div`
  overflow: hidden;
`;

const EmblaContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const EmblaSlide = styled.div`
  flex: 0 0 auto;
`;

const StyledButton = styled.button<{ active?: boolean }>`
  padding: 8px 16px;
  border-radius: 15px;
  border: ${({ active, theme }) =>
    active ? `1px solid ${theme.colors.primary}` : '1px solid #ccc'};
  background-color: ${({ active, theme }) => (active ? theme.colors.primaryRGB : 'transparent')};
  color: ${({ active, theme }) => (active ? theme.colors.black : theme.colors.gray800)};
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  transition:
    background-color 0.3s,
    color 0.3s;

  @media (hover: hover) {
    &:hover {
      background-color: ${({ active, theme }) => (active ? theme.colors.primary : '#f0f0f0')};
    }
  }
`;
